module.exports = __webpack_public_path__ + "static/media/ImagePharm.69385316.png";